import {
  createSlice,
  createAsyncThunk,
  combineReducers,
  configureStore,
  AsyncThunkOptions,
} from '@reduxjs/toolkit'
import store, { configSlice, notesSlice } from '..'
import { protoRoot } from '../../protos'
import { deepCopy, getShortId } from '@nyanyajs/utils'
import { getContent, getId } from './methods'
import { alert } from '@saki-ui/core'
import i18n from '../../modules/i18n/i18n'
import { storage } from '../storage'

const t = i18n.t

let subTodoCountMap: {
  [k: string]: number
} = {}

export const initSubTodoCountMap = () => {
  subTodoCountMap = {}
}

export const getDefaultLabels = () => {
  const labels: protoRoot.note.PageItem.ILabelItem[] = [
    {
      id: getShortId(13),
      name: t('defaultLabelReady', {
        ns: 'todoPage',
      }),
      bindStatus: 0,
    },
    {
      id: getShortId(13),
      name: t('defaultLabelProcessing', {
        ns: 'todoPage',
      }),
      color: '#cf222e',
      bindStatus: 0,
    },
    {
      id: getShortId(13),
      name: t('defaultLabelReviewing', {
        ns: 'todoPage',
      }),
      color: '#1a7f37',
      bindStatus: 0,
    },
    {
      id: getShortId(13),
      name: t('defaultLabelCompleted', {
        ns: 'todoPage',
      }),
      color: '#2e3c50',
      bindStatus: 1,
    },
    {
      id: getShortId(13),
      name: t('defaultLabelClosed', {
        ns: 'todoPage',
      }),
      bindStatus: 0,
    },
  ].map((v, i) => {
    return {
      ...v,
      sort: i,
    }
  })
  return labels
}

export const getSubTodoCount = (
  todoList: protoRoot.note.ITodoListPageItem[],
  id: string,
  statusList: number[]
) => {
  const k = id + statusList.join(';')
  // console.log('notCount', id, subTodoCountMap[k])
  if (subTodoCountMap[k] !== undefined) return subTodoCountMap[k]
  let count = 0
  // const l = todoList.filter((v) => {
  // 	return v.parentId === id && statusList.includes(v.status)
  // })
  // count += l.length

  todoList
    .filter((v) => {
      if (v.parentId === id) {
        // console.log('notCount', id, v.id, v)
        if (statusList.includes(v.status || 0)) {
          count += 1
        }
        return v.parentId === id
      }
      return false
    })
    .forEach((v) => {
      count += getSubTodoCount(todoList, v?.id || '', statusList)
    })

  subTodoCountMap[k] = count
  // console.log(subTodoCountMap[id])

  return count
}

export const getParentIds = (
  todoList: protoRoot.note.ITodoListPageItem[],
  todo: protoRoot.note.ITodoListPageItem,
  ids: string[] = []
): string[] => {
  if (!todo?.parentId) {
    return [todo?.id || '']
  }
  const l = todoList.filter((sv) => sv?.id === todo?.parentId)
  // console.log("SortTodo l", l)
  return ids.concat(getParentIds(todoList, l?.[0], ids)).concat(todo?.id || '')
  // return getParentIds(
  //   todoList.filter((sv) => sv?.id === todo?.parentId)?.[0], ids
  // ).concat(ids)
}
export const getTopParentId = (
  todoList: protoRoot.note.ITodoListPageItem[],
  todo: protoRoot.note.ITodoListPageItem
) => {
  const parentIds = getParentIds(todoList, todo)
  return parentIds[0] === todo.id ? '' : parentIds[0]
}

const getParentId = (
  todoList: protoRoot.note.ITodoListPageItem[],
  todo: protoRoot.note.ITodoListPageItem,
  level: number
): string => {
  const parentIds = getParentIds(todoList, todo)

  const parentId = parentIds[level - 2]

  // console.log("SortTodo", parentIds, parentId, newLevel - parentIds.length)

  if (parentIds.length === 1) {
    if (level === 2) {
      return todo.id || ''
    }
    return ''
  }

  return parentId
}

export const getImportanceColor = (importance: number) => {
  if (importance === 5) {
    return '#ff0000'
  } else if (importance === 4) {
    return '#800080'
  } else if (importance === 3) {
    return '#008000'
  } else if (importance === 2) {
    return '#0e9eff'
  } else if (importance === 1) {
    return '#f5aab9'
  }
  return '#999'
}

export const sortTodoList = (
  todoList: protoRoot.note.ITodoListPageItem[],
  initSort: boolean = false
) => {
  // 1. 初始化排序值（如果需要）
  if (initSort) {
    todoList.forEach((v, i) => {
      v.sort = todoList.length - i
    })
  }

  // 2. 单次排序，内部处理优先级
  todoList.sort((a, b) => {
    // 优先级 1：重要性 (importance) 降序
    // 假设红星是 5，空星是 -1 或 0
    const impA = Math.max(0, Number(a.importance) || 0)
    const impB = Math.max(0, Number(b.importance) || 0)
    // console.log('sortTodoList', impB, impA)
    if (impB !== impA) {
      return impB - impA
    }

    // 2. 优先级：状态 (status) - 未完成(0)在前，已完成(1)在后
    const statA = a.status || 0
    const statB = b.status || 0
    if (statA !== statB) return statA - statB // 升序：0 -> 1

    // 3. 优先级：自定义排序位 (sort)
    const sortA = a.sort || 0
    const sortB = b.sort || 0
    return sortB - sortA // 降序
  })

  // console.log('sortTodoList', todoList)
}

export const getSubTodoIds = (
  todoList: protoRoot.note.ITodoListPageItem[],
  todoId: string
) => {
  let l: string[] = []
  todoList
    .filter((v) => {
      // l = l.concat(getSubIds(v))
      return v.parentId === todoId
    })
    .forEach((v) => {
      l.push(v.id || '')
      l = l.concat(getSubTodoIds(todoList, v?.id || ''))
    })
  return l
}

export const getTodoList = ({
  categoryId,
  noteId,
  pageId,
}: {
  noteId: string
  categoryId: string
  pageId: string
}) => {
  const result = getContent({ categoryId, noteId, pageId })
  return result.todoList || []
}

export const todoListConvertToContent = (
  todoList: protoRoot.note.ITodoListPageItem[]
) => {
  return JSON.stringify(todoList)
}

export const getTodoProgress = ({
  categoryId,
  noteId,
  pageId,
}: {
  noteId: string
  categoryId: string
  pageId: string
}) => {
  let progress = 0
  let completed = 0
  let total = 0
  const todoList = getTodoList({
    noteId,
    categoryId,
    pageId,
  })
  if (todoList?.length) {
    completed = todoList?.filter((v) => v.status === 1).length
    total = todoList.length
    progress = Math.round((completed / total) * 10000) / 100
  }

  return {
    progress,
    completed,
    total,
  }
}

export const todoMethods = {
  AddTodo: createAsyncThunk(
    'notes/AddTodo',
    async (
      payload: {
        noteId: string
        categoryId: string
        pageId: string
        data: {
          title: string
          importance: 5 | 4 | 3 | 2 | 1 | 0
          parentId?: string
          dueDate?: number
        }
      },
      thunkAPI
    ) => {
      const { categoryId, noteId, pageId, data } = payload

      const todoList = getTodoList({ categoryId, noteId, pageId })

      const todo: protoRoot.note.ITodoListPageItem = {
        id: getId(),
        displayId: 'SA-' + (todoList.length + 1),
        // id,
        title: data.title,
        status: 0,
        importance: data.importance,
        dueDate: data?.dueDate || -1,
        parentId: data?.parentId || '',

        createTime: Math.floor(new Date().getTime() / 1000),
        lastUpdateTime: Math.floor(new Date().getTime() / 1000),
        sort: todoList.length + 1,

        deleteTime: -1,
        deleteUserId: [],
        localUpdateTime: -1,
      }

      thunkAPI.dispatch(
        notesSlice.actions.addTodo({
          noteId,
          categoryId,
          pageId,
          todo,
        })
      )
    }
  ),
  SortTodo: createAsyncThunk(
    'notes/SortTodo',
    (
      payload: {
        noteId: string
        categoryId: string
        pageId: string
        data: {
          newLevel: number
          oldLevel: number
          oldId: string
          newId: string
          pId: string
        }
      },
      thunkAPI
    ) => {
      try {
        const { categoryId, noteId, pageId, data } = payload
        let { newLevel, newId, oldLevel, oldId, pId } = data

        const todoList = getTodoList({ categoryId, noteId, pageId })

        if (!todoList?.length) return

        if (!pId) {
          pId = newId
        }

        console.log('SortTodo', data, newLevel, newId, oldLevel, oldId, pId)

        let oldIndex = -1
        let newIndex = -1
        let pIndex = -1
        todoList.some((v, i) => {
          const id = v?.id || ''
          if (id === oldId) {
            oldIndex = i
          }
          if (id === newId) {
            newIndex = i
          }
          if (id === pId) {
            pIndex = i
          }
          return oldIndex >= 0 && newIndex >= 0 && pIndex >= 0
        })

        // ;[sv.data[i], sv.data[i + 1]] = [sv.data[i + 1], sv.data[i]]

        const parentId = getParentId(todoList, todoList[pIndex], newLevel)

        const subIds = getSubTodoIds(todoList, todoList[oldIndex]?.id || '')

        console.log(
          'SortTodo ParentId',
          subIds,
          todoList[oldIndex].id,
          todoList[pIndex].id,
          parentId,
          pIndex,
          newIndex,
          oldIndex
        )
        console.log(
          todoList[oldIndex].id,
          parentId,
          todoList[oldIndex].id,
          todoList[pIndex].id
        )

        if (
          todoList[oldIndex].id === parentId ||
          (todoList[oldIndex].id === todoList[pIndex].id &&
            oldLevel === newLevel)
        ) {
          console.log('SortTodo 不能自己搞自己')
          return
        }
        if (subIds.includes(todoList[pIndex].id || '')) {
          console.log('SortTodo 不能自己搞自己下级')
          return
        }

        todoList[oldIndex].parentId = parentId

        console.log(
          'SortTodo',
          oldLevel,
          newLevel,
          todoList[oldIndex],
          todoList[newIndex],
          todoList[pIndex]
        )

        // todoList[oldIndex].parentId = todoList[newIndex].parentId

        console.log('SortTodo', deepCopy(todoList), oldIndex, newIndex, pIndex)

        // const oldItem = todoList[oldIndex]

        // const newList: typeof todoList = []

        // todoList.forEach((v, i) => {
        //   if (i === oldIndex - 1) {
        //     return
        //   }
        //   if (i === newIndex - 1) {
        //     newList.push(oldItem)
        //   }
        //   newList.push(v)

        // })

        // ;[todoList[originalIndex], todoList[targetIndex]] = [
        //   todoList[targetIndex],
        //   todoList[originalIndex],
        // ]

        let originalIndex = oldIndex
        let targetIndex = newIndex

        if (oldLevel === 1 && newLevel === 1) {
          const parentIds = getParentIds(todoList, todoList[pIndex])
          console.log(
            'SortTodo 都是一级',
            subIds,
            parentIds,
            oldIndex,
            newIndex,
            todoList[newIndex],
            pIndex,
            todoList[pIndex]
          )
          // 最后一个
          if (newIndex === pIndex) {
            let parentIdIndex = -1

            todoList.some((v, i) => {
              const id = v?.id || ''
              if (id === parentIds[0]) {
                parentIdIndex = i
              }
              return parentIdIndex >= 0
            })
            targetIndex = parentIdIndex
            console.log(
              'SortTodo 跳到最后一个且有下级',
              parentIdIndex,
              subIds,
              parentIds,
              todoList[pIndex],
              pIndex
            )
          } else {
            const subIds = getSubTodoIds(todoList, todoList[newIndex]?.id || '')
            const parentIds = getParentIds(todoList, todoList[newIndex])
            console.log('SortTodo 都是一级 看看是否是树todo', subIds, parentIds)
            if (subIds.length > 0 || parentIds.length > 1) {
              console.log(
                'SortTodo 都是一级 是树todo~!!!',
                subIds,
                parentIds,
                parentIds[0]
              )

              todoList.some((v, i) => {
                const id = v?.id || ''
                // console.log("SortTodo 都是一级 是树todo~!!!", pIndex, newIndex, parentId, v, id, parentIds[0])
                if (id === parentIds[0]) {
                  // console.log("SortTodo 都是一级 是树todo~!!!", v)

                  targetIndex = i
                  return true
                }
              })
            }
          }
        }

        if (originalIndex < targetIndex) {
          for (
            let i = originalIndex;
            i < targetIndex - (pIndex === newIndex ? 0 : 1);
            i++
          ) {
            ;[todoList[i], todoList[i + 1]] = [todoList[i + 1], todoList[i]]
          }
        } else {
          for (let i = originalIndex; i > targetIndex; i--) {
            ;[todoList[i], todoList[i - 1]] = [todoList[i - 1], todoList[i]]
          }
        }

        sortTodoList(todoList, true)

        console.log('SortTodo', deepCopy(todoList))

        // // let tempSort = todoList[oldIndex].sort
        // // todoList[oldIndex].sort = todoList[newIndex].sort
        // // todoList[newIndex].sort = tempSort
        // // 如果拖拽到子元素的话。那么对方的pearentId也得copy，如果对方没有，那么则为一级

        thunkAPI.dispatch(
          notesSlice.actions.sortTodo({
            noteId,
            categoryId,
            pageId,
            sort: {
              list: todoList?.map((todo) => {
                return {
                  id: todo.id,
                  sort: todo.sort,
                  parentId: todo.parentId,
                }
              }),
            },
          })
        )
      } catch (error) {
        console.error(error)
      }
    }
  ),
  MoveSortTodo: createAsyncThunk(
    'notes/MoveSortTodo',
    (
      payload: {
        noteId: string
        categoryId: string
        pageId: string
        todoId: string
        type: 'Top' | 'Bottom'
      },
      thunkAPI
    ) => {
      const { categoryId, noteId, pageId, todoId, type } = payload
      let todoList = getTodoList({ categoryId, noteId, pageId })

      if (!todoList?.length) return

      // let originalIndex = 0
      // let targetIndex = 0

      todoList.some((v, i) => {
        if (v.id === todoId) {
          // originalIndex = i

          if (type === 'Top') {
            v.sort = 100000
          }
          if (type === 'Bottom') {
            v.sort = -1
          }
          return true
        }
      })

      // if (type === 'Top') {
      //   targetIndex = 0
      // }
      // if (type === 'Bottom') {
      //   targetIndex = todoList.length - 1
      // }

      // if (originalIndex < targetIndex) {
      //   for (let i = originalIndex; i < targetIndex; i++) {
      //     ;[todoList[i], todoList[i + 1]] = [todoList[i + 1], todoList[i]]
      //   }
      // } else {
      //   for (let i = originalIndex; i > targetIndex; i--) {
      //     ;[todoList[i], todoList[i - 1]] = [todoList[i - 1], todoList[i]]
      //   }
      // }
      todoList.sort((a, b) => {
        return (b.sort || 0) - (a.sort || 0)
      })

      sortTodoList(todoList, true)

      thunkAPI.dispatch(
        notesSlice.actions.sortTodo({
          noteId,
          categoryId,
          pageId,
          sort: {
            list: todoList?.map((todo) => {
              return {
                id: todo.id,
                sort: todo.sort,
                parentId: todo.parentId,
              }
            }),
          },
        })
      )
    }
  ),
  // UpdateTodo: createAsyncThunk(
  //   'notes/UpdateTodo',
  //   (
  //     payload: {
  //       noteId: string
  //       categoryId: string
  //       pageId: string
  //       todoId: string
  //       data: {
  //         title?: string
  //         note?: string
  //         parentId?: string
  //         importance?: number
  //       }
  //     },
  //     thunkAPI
  //   ) => {
  //     const { categoryId, noteId, pageId, todoId, data } = payload
  //     let todoList = getTodoList({ categoryId, noteId, pageId })

  //     if (!todoList?.length) return

  //     todoList = todoList.map((v) => {
  //       if (v.id === todoId) {
  //         if (data?.parentId !== undefined) {
  //           v = {
  //             ...v,
  //             parentId: data?.parentId,
  //           }
  //         }
  //         if (data?.importance !== undefined) {
  //           v = {
  //             ...v,
  //             importance: data?.importance,
  //           }
  //         }
  //         if (data?.title) {
  //           v = {
  //             ...v,
  //             title: data.title
  //           }
  //         }
  //         if (data?.note && data?.note !== "blank") {
  //           v = {
  //             ...v,
  //             note: data.note
  //           }
  //         }
  //       }
  //       return v
  //     })

  //     if (data?.importance !== undefined || data?.parentId !== undefined) {

  //       sortTodoList(todoList, true)
  //     }

  //     thunkAPI.dispatch(
  //       notesSlice.actions.updatePage({
  //         noteId,
  //         categoryId,
  //         pageId,
  //         data: {
  //           content: todoListConvertToContent(todoList)
  //         },
  //       })
  //     )
  //   }
  // ),
  // CompleteTodo: createAsyncThunk(
  //   'notes/CompleteTodo',
  //   (
  //     payload: {
  //       noteId: string
  //       categoryId: string
  //       pageId: string
  //       todoIds: string[]
  //     },
  //     thunkAPI
  //   ) => {
  //     const { categoryId, noteId, pageId, todoIds } = payload

  //     let todoList = getTodoList({ categoryId, noteId, pageId })
  //     if (!todoList?.length) return
  //     todoList = todoList.map((v) => {
  //       return {
  //         ...v,
  //         status: todoIds.includes(v?.id || '') ? 1 : 0,
  //       }
  //     })

  //     sortTodoList(todoList)

  //     thunkAPI.dispatch(
  //       notesSlice.actions.updatePage({
  //         noteId,
  //         categoryId,
  //         pageId,
  //         data: {
  //           content: todoListConvertToContent(todoList)
  //         },
  //       })
  //     )
  //   }
  // ),
  DeleteTodo: createAsyncThunk(
    'notes/DeleteTodo',
    (
      payload: {
        noteId: string
        categoryId: string
        pageId: string
        todoId: string
      },
      thunkAPI
    ) => {
      alert({
        title: t('delete', {
          ns: 'common',
        }),
        content: t('deleteThisTodo', {
          ns: 'todoPage',
        }),
        cancelText: t('cancel', {
          ns: 'common',
        }),
        confirmText: t('delete', {
          ns: 'common',
        }),
        onCancel() {},
        async onConfirm() {
          const { categoryId, noteId, pageId, todoId } = payload

          thunkAPI.dispatch(
            notesSlice.actions.deleteTodo({
              noteId,
              categoryId,
              pageId,
              todoId,
            })
          )

          thunkAPI.dispatch(
            configSlice.actions.setShowAsideContentModal({
              visible: false,
            })
          )
        },
      }).open()
    }
  ),
}
